<template>
  <nav class="content mod--nav LKHeader">
    <router-link :to="homeRoute" class="nav__logo w-nav-brand">
      <div class="nav__logo__inner-wrapper">
        <span v-if="hasLogo" class="nav__logo-img" v-html="LogoSvg" />
        <img
          v-else
          :src="isGeneralSite ? '/logo_general.png' : '/logo.svg'"
          :class="{
            'nav__logo-img': !isGeneralSite,
            'nav__logo-general-img': !!isGeneralSite,
          }"
        >
        <template v-if="!$vuetify.breakpoint.xs">
          <span v-if="isGeneralSite" class="nav__logo-title">
            ФЕДЕРАЛЬНАЯ ИНФОРМАЦИОННАЯ СИСТЕМА <br>ОЦЕНКИ КАЧЕСТВА ОБРАЗОВАНИЯ
          </span>
          <span v-else-if="isSoop" class="nav__logo-title nav__logo-title__soop">
            Система обеспечения <br>оценочных процедур
          </span>
          <span v-else class="nav__logo-title nav__logo-title__fioco">
            <span>ⵀИОКО</span> <br><small>ⵀедеальный институт <br>оценки качества образования</small>
          </span>
        </template>
      </div>
    </router-link>

    <div class="nav__link-container">
      <div class="nav__link-box">
        <template v-for="item in headerMenu">
          <template v-if="((item.permission && !$access(item.permission)) || !!item.disabled)">
            <div
              v-if="authorized"
              :key="item.id"
              :class="{
                general: !!isGeneralSite,
              }"
              class="nav__link nav__link__disabled w-inline-block"
            >
              <label
                class="text-lg-bold mod--nav"
                v-text="item.label"
              />
            </div>
          </template>
          <template v-else>
            <v-menu
              v-if="item.items"
              :key="item.id"
              offset-y
              close-on-click
              close-on-content-click
            >
              <template #activator="{ on, attrs }">
                <a
                  href="#"
                  :class="{
                    'w--current': item.id === currentMenuId,
                    general: !!isGeneralSite,
                  }"
                  class="nav__link w-inline-block"
                  v-bind="attrs"
                  v-on="on"
                  @click="currentMenuId = item.id"
                >
                  <span
                    class="text-lg-bold mod--nav"
                    v-text="item.label"
                  />
                </a>
              </template>
              <v-list>
                <v-list-item
                  v-for="(subItem) in item.items"
                  :key="subItem.id"
                >
                  <v-list-item-title>
                    <LKHeaderItem
                      :item="subItem"
                      :class="{
                        general: !!isGeneralSite,
                      }"
                      class="nav__link w-inline-block"
                    />
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <LKHeaderItem
              v-else
              :key="item.id"
              :item="item"
              :class="{
                general: !!isGeneralSite,
                'w--current': item.id === currentMenuId
              }"
              class="nav__link w-inline-block"
              @click.native="currentMenuId = item.id"
            />
          </template>
        </template>
        <LKHeaderItem
          v-if="scanMenu.label"
          :item="scanMenu"
          :class="{
            general: !!isGeneralSite,
            'w--current': scanMenu.id === currentMenuId,
          }"
          class="nav__link w-inline-block"
          @click.native="currentMenuId = scanMenu.id"
        />
      </div>

      <slot name="notifications" />

      <LKHeaderUserMenu
        v-if="authorized"
        :profile="profile"
        :reportless="reportless"
      />

      <LKHeaderAuthLink
        :authorized="authorized"
      />

      <LKHeaderBurgerMenu
        v-model="currentMenuId"
        :list="headerMenu"
        :scan-list="scanMenuBurger"
      />
    </div>

    <div
      v-if="userPermissionLabel"
      class="LKHeader__user-label"
      v-text="userPermissionLabel"
    />
  </nav>
</template>

<script>
import { HOME_ROUTES } from '@/views/Home/utils'

import LKHeaderItem from './LKHeader/LKHeaderItem.vue'
import LKHeaderUserMenu from './LKHeader/LKHeaderUserMenu.vue'
import LKHeaderBurgerMenu from './LKHeader/LKHeaderBurgerMenu.vue'
import LKHeaderAuthLink from './LKHeader/LKHeaderAuthLink.vue'
import { LK_PASSPORT_ROUTES } from '@/views/LKPassport/utils'
import SiteDetectionMixin from '@/helpers/siteDetectionMixin'
import {
  analyticsClosedPermissions as AnalyticsClosedPermissions,
  lkPassportPermissions as PassportPermissions,
} from '@/helpers/enums/permission-models'

const HEADER_MENU = [
  {
    id: 1,
    label: 'Обмен данными',
    link: '/',
  },
]

export default {
  name: 'LKHeader',
  components: {
    LKHeaderItem,
    LKHeaderAuthLink,
    LKHeaderUserMenu,
    LKHeaderBurgerMenu,
  },
  mixins: [SiteDetectionMixin],
  props: {
    reportless: Boolean,
    userPermissionLabel: String,
    authorized: Boolean,
    profile: {
      type: Object,
      // required: true,
    },
    accessToScan: Array,
  },
  data: () => ({
    hasLogo: false,
    homeRoute: { name: HOME_ROUTES.INDEX },
    currentMenuId: null,
  }),
  computed: {
    headerMenu() {
      if (this.isSoop) {
        return HEADER_MENU.filter((o) => o.id !== 1)
      }

      if (this.isNiko || this.isMed || this.isSod) {
        return HEADER_MENU
      }

      const PASSPORT_ITEM = {
        id: 3,
        label: 'Паспорт',
        disabled: true,
      }
      {
        const canRead = this.$access(PassportPermissions.read, false)
        const canList = this.$access(PassportPermissions.list, true)
        const canEdit = this.$access(PassportPermissions.edit, false)
        if (canRead || canList) {
          delete PASSPORT_ITEM.disabled
          if ((canRead && canEdit) && canList) {
            PASSPORT_ITEM.items = [
              {
                id: 1,
                label: 'Паспорт пользователя',
                route: { name: LK_PASSPORT_ROUTES.LAYOUT },
              },
              {
                id: 2,
                label: 'Статистика',
                route: { name: LK_PASSPORT_ROUTES.STATISTICS },
              },
            ]
          } else if (canRead && canEdit) {
            PASSPORT_ITEM.route = { name: LK_PASSPORT_ROUTES.LAYOUT }
          } else {
            PASSPORT_ITEM.route = { name: LK_PASSPORT_ROUTES.STATISTICS }
          }
        }
      }

      const menu = [
        {
          id: 2,
          label: 'Аналитика',
          link: 'https://analytics-fisoko.obrnadzor.gov.ru/',
        },
        PASSPORT_ITEM,
      ]

      if (!this.authorized || this.$access(AnalyticsClosedPermissions.access, false)) {
        return HEADER_MENU.concat(menu.filter((item) => item.id !== 2))
      }

      return HEADER_MENU.concat(menu)
    },
    scanMenu() {
      if (this.isNiko || this.isSod || this.isSoop) {
        return {}
      }

      if (this.accessToScan.includes('ixora')) {
        return {
          id: 4,
          label: 'Сканирование бланков',
          link: 'https://vpr.ixora.ru/',
        }
      }

      return {}
    },
    scanMenuBurger() {
      if (!this.scanMenu.label) return []

      return [this.scanMenu]
    },
  },
  watch: {
    $route: {
      handler(v) {
        this.updateCurrentMenuId(v)
      },
      immediate: true,
    },
  },
  async created() {
    if (!this.isGeneralSite) {
      this.hasLogo = false
      this.LogoSvg = (await import(
      /* webpackChunkName: "logo.svg" */
        '!raw-loader!@/../public/logo.svg'
      )).default
      this.hasLogo = true
    }
  },
  methods: {
    updateCurrentMenuId(route) {
      const menuItem = this.headerMenu.find(
        (item) => item.link === route.fullPath || item.route?.name === route.name,
      )
      if (menuItem) {
        this.currentMenuId = menuItem.id
      }
    },
  },
}
</script>

<style lang="scss">

.LKHeader {
  position: relative;

  & &__name {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__menu {
    max-width: 160px;
  }

  &__user-label {
    position: absolute;
    right: 0;
    bottom: -36px;
    font-weight: 700;
    text-align: right;

    @media screen and (max-width: 767px) {
      bottom: -50px;
      padding: 8px 20px;
    }
  }

  .nav__link__disabled {
    color: $webflow-color-grey;

    &:hover::after {
      border: none !important;
    }
  }
}

$animation-delay: 0.1s;

.nav__logo__inner-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    .logo-line {
      animation-name: logo-animation;
      animation-duration: 1s;
      animation-timing-function: ease-in-out;
      animation-iteration-count: 1;

      @for $i from 1 through 5 {
        &.is-#{$i} {
          animation-delay: $i * $animation-delay;
        }
      }
    }
  }
}

@keyframes logo-animation {
  16.65% {
    transform: translateY(16px);
  }

  33.3% {
    transform: translateY(-12px);
  }

  49.95% {
    transform: translateY(8px);
  }

  66.6% {
    transform: translateY(-4px);
  }

  83.25% {
    transform: translateY(2px);
  }

  100% {
    transform: translateY(0);
  }
}
</style>
